import React from 'react';
import NProgress from 'nprogress';
import { Button, Input, Modal } from '@avila-tek/ui/src';
import { useMutation } from '@apollo/client';
import { RESET_PASSWORD } from '../../../graphql/mutation';
import { useNotify } from '../../../hooks';

interface ResetPasswordModalProps {
  isOpen: boolean;
  setOpen: React.Dispatch<React.SetStateAction<boolean>>;
}

function ResetPasswordModal({ isOpen, setOpen }: ResetPasswordModalProps) {
  const notify = useNotify();

  const [email, setEmail] = React.useState('');
  const [disabled, setDisabled] = React.useState(false);

  const [resetPassword] = useMutation<{
    resetPassword: {
      success: boolean;
      err: string;
    };
  }>(RESET_PASSWORD);

  const onSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    try {
      e.preventDefault();
      NProgress.start();
      if (disabled) return;
      setDisabled(true);

      const { data } = await resetPassword({
        variables: {
          data: {
            email,
          },
        },
      });

      if (data.resetPassword.success) {
        notify(
          'Se ha enviado un correo a tu email para cambiar la contraseña',
          'success'
        );
        setOpen(false);
      } else {
        notify(data.resetPassword.err, 'error');
      }
    } catch (error) {
      console.log(error);
      notify(error.message, 'error');
    } finally {
      NProgress.done();
      setDisabled(false);
    }
  };

  return (
    <Modal isOpen={isOpen} setOpen={setOpen} className="md:max-w-[40%]  ">
      <form method="POST" onSubmit={onSubmit}>
        <div className="bg-white rounded-lg ">
          <Modal.Title title="Reestablecer contraseña" setIsOpen={setOpen} />
          <div className="flex flex-col p-6">
            {/* description */}
            <span className="text-text-gray ">
              Ingresa tu email y te enviaremos un correo electrónico con el
              enlace para reestablecer la contraseña.
            </span>
            <div className="w-full my-4">
              <Input
                label="Email"
                name="email"
                onChange={(e) => setEmail(e.target.value)}
                type="email"
              />
            </div>
            <Button className="mt-5">Reestablecer contraseña</Button>
          </div>
        </div>
      </form>
    </Modal>
  );
}

export default ResetPasswordModal;
